export default __webpack_public_path__ + "static/media/CaffeLatte.9634b74b.png";